function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEarth({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26",
    id: "Earth",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13 0C5.826 0 0 5.826 0 13s5.826 13 13 13 13-5.826 13-13S20.174 0 13 0zm0 1c6.633 0 12 5.367 12 12s-5.367 12-12 12S1 19.633 1 13 6.367 1 13 1zm0 5c-.231 0-.485.117-.773.43-.29.312-.583.81-.832 1.449-.234.597-.423 1.32-.565 2.121h4.34c-.142-.8-.331-1.524-.565-2.121-.249-.638-.543-1.137-.832-1.45C13.485 6.118 13.231 6 13 6zm-1.9.266A6.993 6.993 0 0 0 6.68 10h3.127c.152-.926.375-1.766.656-2.484.185-.474.397-.89.637-1.25zm3.8 0c.24.36.452.776.637 1.25.28.718.504 1.558.656 2.484h3.127a6.993 6.993 0 0 0-4.42-3.734zM6.293 11A7.017 7.017 0 0 0 6 13c0 .696.105 1.366.293 2h3.394a19.076 19.076 0 0 1-.115-2c0-.696.048-1.357.116-2H6.293zm4.402 0c-.071.638-.123 1.3-.123 2s.052 1.36.123 2h4.61c.071-.64.123-1.3.123-2s-.052-1.362-.123-2h-4.61zm5.617 0c.068.643.116 1.304.116 2s-.048 1.357-.116 2h3.395A7.003 7.003 0 0 0 20 13c0-.696-.105-1.366-.293-2h-3.395zm-9.63 5a6.992 6.992 0 0 0 4.416 3.732 6.566 6.566 0 0 1-.635-1.246c-.28-.718-.504-1.56-.656-2.486H6.682zm4.15 0c.141.8.33 1.527.563 2.123.249.639.543 1.136.832 1.45.288.312.542.427.773.427.231 0 .485-.115.773-.428.29-.313.583-.81.832-1.449.233-.596.422-1.323.563-2.123h-4.336zm5.361 0a12.462 12.462 0 0 1-.656 2.486 6.566 6.566 0 0 1-.635 1.246A6.992 6.992 0 0 0 19.318 16h-3.125z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible",
    style: {
      lineHeight: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textTransform: "none",
      blockProgression: "tb"
    },
    fill: "#13675f",
    className: "color000000 svgShape"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarth);
export default __webpack_public_path__ + "static/media/earth.5f6b845ec55d7cd16b5b56fdda2ee5e1.svg";
export { ForwardRef as ReactComponent };